"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderRoutes = exports.renderRoute = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const LazyRoute_1 = require("./LazyRoute");
const NotFound_1 = require("./NotFound");
const PrivateRoute_1 = require("./PrivateRoute");
function renderRoute(_a) {
    var { privateRoute, component } = _a, routeProps = tslib_1.__rest(_a, ["privateRoute", "component"]);
    const key = `${routeProps.exact ? "exact" : "non-exact"}-${routeProps.path}-${privateRoute ? "private" : "public"}-${component.name}`;
    if (privateRoute) {
        return jsx_runtime_1.jsx(PrivateRoute_1.PrivateRoute, Object.assign({ component: component }, routeProps), key);
    }
    return jsx_runtime_1.jsx(LazyRoute_1.LazyRoute, Object.assign({ component: component }, routeProps), key);
}
exports.renderRoute = renderRoute;
function renderRoutes(routes) {
    let children = jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: routes.filter((route) => route.path || !route.component).map(renderRoute) }, void 0);
    const notFoundRoute = routes.find((route) => !route.path && route.component);
    if (notFoundRoute) {
        const CaptureRouteNotFound = NotFound_1.useCaptureRouteNotFound(notFoundRoute.component);
        children = jsx_runtime_1.jsx(CaptureRouteNotFound, { children: children }, void 0);
    }
    return jsx_runtime_1.jsx(react_router_dom_1.Switch, { children: children }, void 0);
}
exports.renderRoutes = renderRoutes;
//# sourceMappingURL=Route.js.map